const globalState = (() => {
  let state = {}
  let listeners = []

  return {
    getState: (key) => state[key],
    setState: (key, value) => {
      state[key] = value
      listeners.forEach((listener) => listener(key, value))
    },
    subscribe: (listener) => {
      listeners.push(listener)
      return () => {
        listeners = listeners.filter((l) => l !== listener)
      }
    },
  }
})()

export default globalState
